'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ValidacionCampo = function ValidacionCampo(_ref) {
  var mensaje = _ref.mensaje;
  return _react2.default.createElement('div', {
    className: 'ui-message ui-messages-error ui-corner-all'
  }, mensaje);
};

ValidacionCampo.propTypes = process.env.NODE_ENV !== "production" ? {
  mensaje: _propTypes2.default.string.isRequired
} : {};
exports.default = ValidacionCampo;
module.exports = exports['default'];